var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#151718"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4001_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0745 14.5641C10.9146 12.8911 12.2035 11.4847 13.7971 10.5021C15.3907 9.51948 17.2261 8.99941 19.0983 9C21.8197 9 24.106 9.99973 25.854 11.6306L22.9588 14.5268C21.9116 13.526 20.5807 13.0161 19.0983 13.0161C16.4677 13.0161 14.241 14.7934 13.4483 17.1796C13.2463 17.7855 13.1312 18.4318 13.1312 19.0983C13.1312 19.7647 13.2463 20.411 13.4483 21.0169C14.242 23.4041 16.4677 25.1804 19.0983 25.1804C20.4565 25.1804 21.6127 24.8219 22.5175 24.2161C23.0421 23.8707 23.4911 23.4226 23.8376 22.8987C24.184 22.3749 24.4206 21.7863 24.5331 21.1684H19.0983V17.2624H28.6088C28.7279 17.9228 28.7926 18.6115 28.7926 19.3275C28.7926 22.4034 27.6919 24.9926 25.7813 26.7497C24.111 28.2927 21.8248 29.1965 19.0983 29.1965C17.772 29.197 16.4586 28.9362 15.2332 28.4289C14.0078 27.9216 12.8943 27.1778 11.9565 26.24C11.0187 25.3022 10.2749 24.1887 9.7676 22.9633C9.26031 21.7379 8.99947 20.4245 9 19.0983C9 17.4684 9.38979 15.9274 10.0745 14.5641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4001_807"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 20.1965,
    height: 20.1965,
    rx: 10.0983,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.097f31e0bec8f22abb9c864e30aabd2f.svg";
export { ForwardRef as ReactComponent };